import { IMPERIAL } from "@/lib/showcaseCity";

/* Unit localisation for the public showcase only.
   A plant owner in Texas thinks in cubic yards, PSI and gallons — if the demo opens in
   m³ and MPa it reads as foreign in the first two seconds. Detection is best-effort from
   the browser locale/timezone; the real app stays metric until the org-level switcher is
   built. */
// Units follow the detected demo city, not the browser language — an Australian plant
// with a US-English browser was showing Wollongong streets in cubic yards.
export const IMP = IMPERIAL;

const r = (n, d = 1) => Number(n.toFixed(d));

/** Volume — m³ → cubic yards */
export const vol = (m3) => (IMP ? { v: r(m3 * 1.30795), u: "yd³" } : { v: r(m3), u: "m³" });
/** Mass — kg → lb */
export const mass = (kg) => (IMP ? { v: Math.round(kg * 2.20462), u: "lb" } : { v: r(kg), u: "kg" });
/** Liquid — litres → US gallons */
export const liq = (l) => (IMP ? { v: r(l * 0.264172), u: "gal" } : { v: r(l), u: "L" });
/** Slump — mm → inches */
export const slump = (mm) => (IMP ? { v: r(mm / 25.4, 1), u: "in" } : { v: Math.round(mm), u: "mm" });
/** Strength — MPa → psi, rounded to the nearest 50 like a US spec sheet */
export const strength = (mpa) => (IMP ? { v: Math.round((mpa * 145.038) / 50) * 50, u: "psi" } : { v: r(mpa, 0), u: "MPa" });
/** Mix code — N32-20 reads as 4600 PSI · 3/4" to an American batcher */
export const mixLabel = (code, mpa, aggMm) => {
  if (!IMP) return code;
  const psi = strength(mpa).v;
  const agg = aggMm === 20 ? '3/4"' : aggMm === 14 ? '1/2"' : aggMm === 10 ? '3/8"' : aggMm === 7 ? '1/4"' : `${aggMm}mm`;
  return `${psi} PSI · ${agg}`;
};
/** Big-number formatting with thousands separators */
export const n = (x) => Number(x).toLocaleString();
